
export const notifyNativeApp = (pdfUrl, title = "Report") => {
  if (!pdfUrl) return;
  const fileName = pdfUrl.split("/").pop();

  if (window.ReactNativeWebView) {
    try {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "SHARE_PDF",
          payload: { url: pdfUrl, fileName, title },
        })
      );
    } catch (error) {
      // postMessage isn't available/wired on the native side yet — the
      // query-param channel below is the fallback that's confirmed working.
    }
  }

  try {
    const url = new URL(window.location.href);
    url.searchParams.set("pdfUrl", pdfUrl);
    url.searchParams.set("pdfFileName", fileName);
    window.history.replaceState(null, "", url.toString());
  } catch (error) {
    // Ignore — nothing more we can do to reach the native host.
  }
};

// Click handler for the "Share PDF" button. It only hands the url to the
// native host (see notifyNativeApp above) — it never opens or downloads the
// PDF itself, on any platform. The native app watches the query param and
// handles the actual share/download on its own side.
export const sharePdf = (pdfUrl, title = "Report") => {
  notifyNativeApp(pdfUrl, title);
};
